import React, { ReactElement } from 'react'
import { PandaButton } from '@mindfulchefuk/design-system'

import { css } from 'styled-system/css'

type TOnboardingCartDrawerFooter = {
  hasMinNumberOfRecipes: boolean
  onClickAboveMinRecipes: () => void
  onClickBelowMinRecipes: () => void
}

export const OnboardingCartDrawerFooter = ({
  hasMinNumberOfRecipes,
  onClickAboveMinRecipes,
  onClickBelowMinRecipes,
}: TOnboardingCartDrawerFooter): ReactElement => {
  const { buttonCopy, onButtonClick } = hasMinNumberOfRecipes
    ? { buttonCopy: 'Confirm Recipes', onButtonClick: onClickAboveMinRecipes }
    : { buttonCopy: 'Choose Recipes', onButtonClick: onClickBelowMinRecipes }

  return (
    <footer
      className={css({
        borderTop: '1px solid',
        pt: 6,
        px: 6,
        borderColor: 'pepper.50',
      })}
    >
      <PandaButton
        variant="primary"
        size={['medium', 'large']}
        type="button"
        onClick={onButtonClick}
        fullWidth
        data-testid="footer-button"
      >
        {buttonCopy}
      </PandaButton>
    </footer>
  )
}
